import React from "react";
import { ProjectData } from "../../constants/interfaces";

interface ProjectsProps {
  data: ProjectData
}

export const Projects = (props: ProjectsProps) => {
  return (
    <div id="projects">
      <div className="container">
        <div className="row">
          {/*<div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>*/}
          <div className="col-xs-12 col-md-6" style={{textAlign: "center", width: "100%", paddingTop: "100px", paddingBottom: "100px"}}>
            <div className="about-text">
              <h2>What We Do</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <a href="/projects" type="button" className="btn btn-primary btn-lg"
              style={{color: '#ffffff', backgroundColor: '#0573e8'}}>Our Work</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
